import {takeLatestF, putAll, showSuccess} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {DeleteAnimalListAction, animalBrowserAction} from '../action';
import {getAnimalListVersion} from './get-animal-list-version';

const te = t('animalBrowser');

function* execute({payload: {animalListId, animalType}}: DeleteAnimalListAction): SagaIterator {
    const version = yield* call(getAnimalListVersion, animalListId);
    const response = yield* call(Api.deleteAnimalList, {version}, {animalListId});

    const title = te('deleteAnimalList');

    if (response.isSuccess) {
        yield* put(animalBrowserAction.getAnimalLists(animalType, true));
        yield* put(showSuccess(title, te('animalListDeleted'), false, 'cab-delete-animal-list'));
    } else {
        yield putAll(showBeError(response, title));
    }
}

/**
 * Deletes a saved animal list.
 *
 * @returns The saga watcher for `DELETE_ANIMAL_LIST`.
 */
export function* deleteAnimalListSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/DELETE_ANIMAL_LIST', execute);
}
